import { useState } from "react";
import { History } from "lucide-react";
import { useGetEvaluariDupaCui } from "@/hooks/api/query/useGetEvaluariDupaCui";
import {
  etichetaOrigineEvaluare,
  formateazaDataEvaluare,
  textVersiuneDate,
} from "@/utils/notificariRecalculFormatting";

type IstoricEvaluariProps = {
  cui: string | null;
};

function IstoricEvaluari({ cui }: IstoricEvaluariProps) {
  const [deschis, setDeschis] = useState(false);
  const { data, isLoading, isError } = useGetEvaluariDupaCui(cui, {
    enabled: deschis,
  });

  if (!cui) return null;

  return (
    <div data-testid="istoric-evaluari">
      <button
        type="button"
        onClick={() => setDeschis((v) => !v)}
        aria-expanded={deschis}
        data-testid="istoric-evaluari-comuta"
        className="inline-flex items-center gap-1 font-mono text-[10px] text-ds-text-400 hover:text-ds-text-600"
      >
        <History className="h-3 w-3" />
        {deschis ? "Ascunde istoricul evaluărilor" : "Istoric evaluări"}
      </button>

      {deschis && isLoading && (
        <p className="mt-1 font-mono text-[10px] text-ds-text-400">
          Se încarcă istoricul...
        </p>
      )}

      {deschis && isError && (
        <p className="mt-1 font-mono text-[10px] text-ds-red-700">
          Istoricul evaluărilor nu a putut fi încărcat.
        </p>
      )}

      {deschis && !isLoading && !isError && (
        <ul className="mt-1 space-y-1">
          {(data?.data ?? []).length === 0 && (
            <li className="font-mono text-[10px] text-ds-text-400">
              Nicio evaluare înregistrată.
            </li>
          )}
          {(data?.data ?? []).map((evaluare) => (
            <li
              key={`${evaluare.origine}-${evaluare.referinta}`}
              data-testid="istoric-evaluari-rand"
              className="rounded-sm border border-ds-border-200 bg-white px-1.5 py-1 font-mono text-[10px] text-ds-text-600"
            >
              <span className="font-semibold">
                {etichetaOrigineEvaluare(evaluare.origine)}
              </span>
              {" · "}
              {formateazaDataEvaluare(evaluare.data)}
              {" · "}
              {evaluare.nivel_incadrare ?? "fără încadrare"}
              {" · "}
              {evaluare.dimensiune ?? "dimensiune necunoscută"}
              <div className="text-ds-text-400">
                {textVersiuneDate(evaluare)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default IstoricEvaluari;
